.gj{z-index:2;}